export const state = () => ({
  propertyTypes: [],
  rentType: {},
  propertyTypeEnum: {
    HOUSE: 'Rumah',
    APARTMENT: 'Apartemen',
  },
  listingTypeEnum: {
    SECONDARY: 'SECONDARY',
    PRIMARY: 'PRIMARY',
  },
  listingTypes: [
    {
      id: 2,
      name: 'Properti Dijual',
    },
    {
      id: 1,
      name: 'Proyek Terbaru',
    },
  ],
});

export const getters = {
  propertyTypesForFilter(state, getters, rootState) {
    let listingType = rootState.searchListing.selectedListingType;
    let list = JSON.parse(JSON.stringify(state.propertyTypes));
    if (listingType && listingType.id !== 1) {
      list = list.filter((propertyType) => {
        return propertyType.id !== -1;
      });
    }
    return list;
  },
  propertyTypesByListingType(state) {
    // if (rootState.v2.search.selectedListingType.id === 1) {
    //   return [
    //     {
    //       id: 1,
    //       name: 'Rumah',
    //     },
    //     {
    //       id: 2,
    //       name: 'Apartemen',
    //     },
    //   ];
    // } else {
    let list = JSON.parse(JSON.stringify(state.propertyTypes));
    list = list.filter((propertyType) => {
      return propertyType.id !== null && propertyType.id !== -1;
    });
    return list;
    // }
  },
};

export const mutations = {
  set_property_types(state, payload) {
    state.propertyTypes = payload;
  },
  set_rent_type(state, payload) {
    state.rentType = payload;
  },
};

function getPropertyTypeImage(propertyType) {
  const baseUrl = 'https://beliruma.b-cdn.net/public/static/img/property-type/v2';
  const imageMap = {
    1: 'house.svg',
    2: 'apartment.svg',
    3: 'warehouse.svg',
    4: 'shophouse.svg',
    5: 'residential-land.svg',
    6: 'commercial-land.svg',
    7: 'working-space.svg',
    9: 'villa.svg',
    10: 'building.svg',
    11: 'office.svg',
    12: 'factory.svg',
    13: 'commercial-land.svg',
  };
  if (imageMap[propertyType.id]) return `${baseUrl}/${imageMap[propertyType.id]}`;
  return undefined;
}

export const actions = {
  async getPropertyTypes({ commit }) {
    await this.$http.get('/api/master/property-types').then((response) => {
      let list = response.data.data;
      let newList = [
        { id: null, name: 'Semua Tipe Properti' },
        // { id: -1, name: 'Rumah Subsidi', originalId: 1 },
      ];
      if (list) {
        for (let item of list) {
          newList.push({
            id: item.id,
            name: item.name,
            slug: item.slug,
            image: item.image || getPropertyTypeImage(item),
            category_id: item.category_id,
          });
        }
      }
      commit('set_property_types', newList);
    });
  },

  // eslint-disable-next-line no-unused-vars
  async getPropertyTypesHeader({ commit }, { category_id: categoryId }) {
    let response = await this.$http.get('/api/v2/master/property-types', {
      params: {
        category_id: categoryId,
      },
    });
    return response.data.data;
  },
  async getPropertyTypeById({ state, dispatch }, propertyTypeId) {
    await dispatch('getPropertyTypes');
    const propertyType = await state.propertyTypes.find(function (item) {
      return item ? item.id === parseInt(propertyTypeId) : false;
    });
    if (propertyType) return JSON.parse(JSON.stringify(propertyType));
  },

  async getRentTypeById({ commit }, id) {
    await this.$http.get('/api/v2/master/' + id + '/rent-type').then((response) => {
      commit('set_rent_type', response.data.data);
    });
  },

  // eslint-disable-next-line no-empty-pattern
  async getProvinces({}) {
    let response = await this.$http.get('/api/regional/get_provinces');

    return response.data.data;
  },
  // eslint-disable-next-line no-empty-pattern
  async getCitiesByProvinceId({}, province_id) {
    let response = await this.$http.get('/api/regional/get-cities-by-province', {
      params: {
        province_id: province_id,
      },
    });

    return response.data.data;
  },
  // eslint-disable-next-line no-empty-pattern
  async getVillagesByDistrictId({}, district_id) {
    let response = await this.$http.get('/api/regional/get-villages-by-district', {
      params: {
        district_id: district_id,
      },
    });

    return response.data.data;
  },
  // eslint-disable-next-line no-empty-pattern
  async getAreasByCityId({}, city_id) {
    let response = await this.$http.get('/api/regional/get-areas-by-city', {
      params: {
        city_id: city_id,
      },
    });

    return response.data.data;
  },
};
